"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postMobileEventsRequest = void 0;
const typebox_1 = require("@sinclair/typebox");
const post_mobile_event_request_1 = require("./post-mobile-event-request");
exports.postMobileEventsRequest = typebox_1.Type.Array(post_mobile_event_request_1.postMobileEventRequest);
//# sourceMappingURL=post-mobile-events-request.js.map